import type { NavigationItem } from '@/shared/types/layout.ts';
import { EXTERNAL_URL, PATHS } from '@/shared/constants/app/routes.constant.ts';
import { BRAND } from '@/shared/constants/app/brand.ts';
import { cdnImageUrl } from '@platform/media';

/** 헤더 최상위 메뉴. `groups` 가 있으면 메가메뉴, 없으면 단순 링크. */
export const navigationItems: NavigationItem[] = [
  {
    id: 1,
    path: '/products',
    label: '제품',
    groups: [
      {
        id: 11,
        title: '플래그십',
        items: [
          {
            id: 111,
            label: 'XCOST PRO',
            description: '건설 견적의 표준. 표준품셈과 자체자원 기반 통합내역 적산.',
            path: PATHS.PRODUCT_XCOST_PRO,
            badge: 'HOT',
          },
          {
            id: 112,
            label: 'XPIXELS AQC',
            description: '2D/3D CAD·BIM 정보화 도면 기반 마감 수량을 자동 산출.',
            path: PATHS.PRODUCT_XPIXELS_AQC,
          },
          {
            id: 113,
            label: 'XPIXELS SQC',
            description: 'RC구조 정보화 도면 기반 골조 수량을 자동 산출.',
            path: PATHS.PRODUCT_XPIXELS_SQC,
          },
          {
            id: 114,
            label: 'XPIXELS EQC',
            description: '전기설비 수량산출. 배관·배선·기구 물량 산출.',
            path: PATHS.PRODUCT_XPIXELS_EQC,
            badge: 'NEW',
          },
          {
            id: 115,
            label: 'XPIXELS MQC',
            description: '기계설비 수량산출. 덕트·배관·기기 물량 산출.',
            path: PATHS.PRODUCT_XPIXELS_MQC,
            badge: 'NEW',
          },
        ],
      },
      {
        id: 12,
        title: '협업 도구',
        items: [
          {
            id: 121,
            label: '워크노트',
            description: '현장-사무실을 잇는 실시간 업무 노트.',
            path: PATHS.PRODUCT_WORKNOTE,
            badge: 'BETA',
          },
          {
            id: 122,
            label: '통합프로그램 설치',
            description: 'XLauncher를 통해 모든 솔루션을 한번에 설치할 수 있습니다.',
            path: PATHS.DOWNLOAD_THANKS,
          },
        ],
      },
    ],
    promo: {
      title: '합리적인 플랜으로 바로 시작',
      description: 'XCOST와 XPIXELS의 전 기능을 저렴하게 제한 없이 사용해보세요.',
      ctaLabel: '시작하기',
      ctaPath: PATHS.STORE,
      accent: BRAND.color,
      imageUrl: cdnImageUrl('pages/header/4f57ba64-1070-4ea5-bc66-acc3fe702abe.png'),
    },
  },

  {
    id: 2,
    path: PATHS.NEWS_NOTICES,
    label: '소식',
    groups: [
      {
        id: 21,
        title: '게시판',
        items: [
          { id: 211, label: '공지사항', description: '회사 및 서비스 공지사항을 알려드립니다.', path: PATHS.NEWS_NOTICES },
          { id: 212, label: '업데이트', description: '프로그램 업데이트 소식을 알려드립니다.', path: PATHS.NEWS_UPDATES },
          { id: 213, label: '이벤트', description: '다양한 프로모션과 행사 및 이벤트를 알려드립니다.', path: PATHS.NEWS_EVENTS },
          { id: 214, label: '자료실', description: '적산자료,표준품셈,표준공사코드 등 자료를 내려받을 수 있습니다.', path: PATHS.NEWS_ARCHIVES },
        ],
      },
      {
        id: 22,
        title: '커뮤니티',
        items: [
          { id: 221, label: '커뮤니티', description: '하우코스트의 공식 커뮤니티 사이트입니다.', path: EXTERNAL_URL.COMMUNITY, target: '_blank' },
          { id: 222, label: '밴드', description: '하우코스트의 공식 네이버 밴드입니다.', path: EXTERNAL_URL.NAVER_BAND, target: '_blank' },
          { id: 223, label: '블로그', description: '하우코스트의 공식 네이버 블로그입니다.', path: EXTERNAL_URL.NAVER_BLOG, target: '_blank' },
        ],
      },
    ]
  },

  {
    id: 3,
    path: PATHS.SUPPORT_FAQS,
    label: '학습 및 지원',
    groups: [
      {
        id: 31,
        title: '학습',
        items: [
          { id: 311, label: '이용 가이드', description: '이용 가이드와 기본기를 학습 할 수 있습니다.', path: PATHS.DOCS },
          { id: 312, label: '품셈해설', description: '필요한 표준품셈만 쉽고 빠르게 확인할 수 있습니다.', path: PATHS.PUMSEM },
          { id: 313, label: '교육 접수', description: '적산 실무 교육을 온라인·오프라인으로 접수합니다.', path: PATHS.EDUCATION },
        ],
      },
      {
        id: 32,
        title: '고객지원',
        items: [
          { id: 321, label: 'FAQ', description: '자주 묻는 질문을 모아 빠르게 확인하세요.', path: PATHS.SUPPORT_FAQS },
          { id: 322, label: '문의', description: '1:1 문의를 남기시면 빠르게 답변드립니다.', path: PATHS.SUPPORT_INQUIRIES },
        ],
      },
    ],
  },

];

/** 구매하기는 여기 없다 — 행동이라 Header 액션 존에 버튼으로 직접 둔다. */
